import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

interface FeaturedArticlesProps {
  featured: typeof articles;
}

export default function FeaturedArticles({ featured }: FeaturedArticlesProps) {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 tracking-wide">
            精选文章
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            最受欢迎的猛男蜕变干货，从这里开始你的蜕变之旅
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5 flex flex-col justify-between flex-1">
                  <div>
                    <span className="inline-block px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-md mb-2">
                      {article.categoryName}
                    </span>
                    <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{article.readTime} 分钟阅读</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}